import { ReactComponent as Icon } from "./find.svg";

const FindIcon = () => {
    return <Icon />;
}

export default FindIcon;